interface AvatarProps {
  name: string;
  size?: "sm" | "md" | "lg";
  tone?: "primary" | "secondary" | "tertiary" | "muted";
  className?: string;
}

const sizeClass: Record<NonNullable<AvatarProps["size"]>, string> = {
  sm: "w-6 h-6 text-[10px]",
  md: "w-9 h-9 text-xs",
  lg: "w-12 h-12 text-sm",
};

const toneClass: Record<NonNullable<AvatarProps["tone"]>, string> = {
  primary: "bg-primary-container text-on-primary-container",
  secondary: "bg-secondary-container text-on-secondary-container",
  tertiary: "bg-tertiary-container text-on-tertiary-container",
  muted: "bg-surface-container-high text-on-surface-variant",
};

/** Initials-based avatar — no external network dependencies. */
export function Avatar({ name, size = "md", tone = "muted", className = "" }: AvatarProps) {
  const initials = name
    .split(/\s+/)
    .map((p) => p[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();
  return (
    <div
      className={`${sizeClass[size]} ${toneClass[tone]} rounded-full border border-outline-variant flex items-center justify-center font-bold ${className}`}
      title={name}
    >
      {initials}
    </div>
  );
}
